import { STUDENT_SELECTION_MODE } from './student-selection-step.types';
import type {
  StudentSelectionMode,
  StudentSelectionModeOption,
} from './student-selection-step.types';

export const STUDENT_SELECTION_MODE_OPTIONS: Array<StudentSelectionModeOption> =
  [
    {
      value: STUDENT_SELECTION_MODE.MANUAL,
      label: 'Select Students Manually',
      shortLabel: 'Manually',
    },
    {
      value: STUDENT_SELECTION_MODE.CLASS,
      label: 'Select by Class',
      shortLabel: 'By Class',
    },
    {
      value: STUDENT_SELECTION_MODE.GROUP,
      label: 'Select by Group',
      shortLabel: 'By Group',
    },
    {
      value: STUDENT_SELECTION_MODE.TAG,
      label: 'Select by Tag',
      shortLabel: 'By Tag',
    },
  ];

export function isStudentSelectionMode(
  value: string,
): value is StudentSelectionMode {
  try {
    switch (value) {
      case STUDENT_SELECTION_MODE.MANUAL:
      case STUDENT_SELECTION_MODE.CLASS:
      case STUDENT_SELECTION_MODE.GROUP:
      case STUDENT_SELECTION_MODE.TAG:
        return true;
      default:
        return false;
    }
  } catch (error) {
    console.error('Failed to check student selection mode', { value, error });
    throw error;
  }
}

export function parseStudentSelectionMode(
  value: string,
): StudentSelectionMode {
  try {
    if (isStudentSelectionMode(value)) {
      return value;
    }

    return STUDENT_SELECTION_MODE.MANUAL;
  } catch (error) {
    console.error('Failed to parse student selection mode', { value, error });
    throw error;
  }
}
